import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  select: {
    minWidth: 240
  },
  datePicker: {
    minWidth: 340
  },
  issuanceCard: {
    '.ant-card-body': {
      padding: 0
    }
  },
  issuanceTable: {
    '.ant-table-tbody > tr > td:first-child': {
      paddingLeft: '24px'
    },
    '.ant-table-thead': {
      display: 'none'
    }
  },
  applicationTable: {
    '.ant-card-body': {
      padding: 0
    }
  },
  applicationTableItem: {
    padding: '0px',
    width: '100%'
  },
  applicationCardItem: {
    borderTop: `1px solid ${token.colorBorder}`,
    borderRadius: 0
  },
  applicationCard: {
    padding: '20px 24px'
  },
  collapseItem: {
    width: '100%',
    borderRadius: 0,
    '.ant-collapse-item .ant-collapse-header': {
      backgroundColor: `${token.colorWhite} !important`,
      padding: '20px 24px !important',
      minHeight: 'unset !important',
      height: 'auto !important',
      whiteSpace: 'normal',
      '.ant-collapse-expand-icon': {
        paddingRight: '24px !important'
      }
    }
  }
}))
